/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  root: {
    padding: '16px 24px'
  }
};
